import { useEffect, useState } from "react";
import api from "../lib/api";

// Shared, cached read of the entity's module/submodule visibility so any page
// can gate an in-page tab/section with a one-liner (`isSubHidden("cip004:rsaw")`)
// without every page re-fetching. Cache is invalidated on full page reload,
// which is also when admin visibility changes take effect.
const EMPTY = { hidden_modules: [], tier_locked: [], hidden_submodules: [] };
let _cache = null;
let _promise = null;

export function useModuleVisibility() {
  const [data, setData] = useState(_cache || EMPTY);
  useEffect(() => {
    let alive = true;
    if (_cache) { setData(_cache); return; }
    if (!_promise) {
      _promise = api.get("/session/modules")
        .then((r) => { _cache = { ...EMPTY, ...r.data }; return _cache; })
        .catch(() => EMPTY);
    }
    _promise.then((d) => { if (alive) setData(d); });
    return () => { alive = false; };
  }, []);

  const isSubHidden = (key) => (data.hidden_submodules || []).includes(key);
  const isModuleHidden = (key) =>
    (data.hidden_modules || []).includes(key) || (data.tier_locked || []).includes(key);
  return { ...data, isSubHidden, isModuleHidden };
}
